import { motion } from 'framer-motion';

// Expo-out easing, the soft, "premium" deceleration those smooth sites use.
export const EASE = [0.22, 1, 0.36, 1];

/** Single element: fade + slide-up when it scrolls into view (once). */
export function Reveal({ children, y = 32, delay = 0, className = '' }) {
    return (
        <motion.div
            className={className}
            initial={{ opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-80px' }}
            transition={{ duration: 0.6, ease: EASE, delay }}
        >
            {children}
        </motion.div>
    );
}

const groupVariants = {
    hidden: {},
    show: { transition: { staggerChildren: 0.08, delayChildren: 0.05 } },
};

const itemVariants = {
    hidden: { opacity: 0, y: 24 },
    show: { opacity: 1, y: 0, transition: { duration: 0.55, ease: EASE } },
};

/**
 * Container for a card grid, children wrapped in <RevealItem> animate in one
 * after another (stagger) as the grid enters view. Pass the grid classes here.
 */
export function RevealGroup({ children, className = '', as = 'div' }) {
    const MotionTag = motion[as] || motion.div;
    return (
        <MotionTag
            className={className}
            variants={groupVariants}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: '-80px' }}
        >
            {children}
        </MotionTag>
    );
}

/** A single staggered child inside <RevealGroup>. */
export function RevealItem({ children, className = '' }) {
    return (
        <motion.div className={className} variants={itemVariants}>
            {children}
        </motion.div>
    );
}
